import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button, Modal, IconButton } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';
import posthog from 'posthog-js';

import './index.scss';
import Color from '@tool/color';
import { CloseIcon20 } from '@styled/icon';
import moSkin from '@store/skin';

interface IProps {
  isOpen: boolean,
  onClose: () => any,
}
interface IState {}

const DModal = styled(Modal)(() => ({
  zIndex: 555555,
}));

const DIconButton = styled(IconButton)(() => ({
  padding: '4px',
}));

const CButton = styled(Button)(() => ({
  width: '90px',
  height: '36px',
  fontSize: '12px',
  fontWeight: 600,
  borderRadius: '5px',
}));

const DButton = styled(CButton)(() => ({
  color: Color.fff,
  backgroundColor: Color.secondary,

  '&:hover': {
    color: Color.fff,
    backgroundColor: Color.secondary,
  },
}));

const EButton = styled(CButton)(() => ({
  marginLeft: '40px',
  border: `1px solid ${Color.ec}`,
  color: Color.c000,
}));

const VipTip = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { partner } = moSkin;
  const { isOpen, onClose } = props;

  useEffect(() => {
    return () => {};
  }, []);

  const onVip = () => {
    posthog.capture('申请开通企业会员人数', {});
    window.location.href = '/vip';
  };

  const onContact = () => {
    const $btn = document.getElementById('nb_invite_ok');
    if ($btn) $btn.click();
  };

  return (
    <DModal open={isOpen} onClose={onClose}>
      <section className="tip-6600">
        <section className="content-666000">
          <p className="title-666">
            <strong>开通会员权限</strong>
            <DIconButton onClick={onClose}>
              <CloseIcon20 color={Color.da} width={26} height={26} />
            </DIconButton>
          </p>
          <p className="text-666000">
            <span>您暂无会员权限，开通企业会员后，</span>
            <span>可以选择所有行业，也可以筛选特定的公司样本数据，</span>
            <span>以及对比所有细分行业的数据。</span>
            <span>如果需要导出报告请咨询网站在线客服或联系您的专属数据顾问!</span>
            <span>薪智24销售在线客服电话: 15021511652(微信同号)!</span>
          </p>
          <p className="line-666">
            <DButton onClick={onVip}>开通企业会员</DButton>
            {partner === 'smartsalary' ? <EButton onClick={onContact}>联系薪酬顾问</EButton> : null}
          </p>
        </section>
      </section>
    </DModal>
  );
};

export default observer(VipTip);
